import { api } from "../api/apiCore";

export function getCompanyWifipoints (data) {
    let url;
    switch(data.user_role) {
        case 'system_admin':
            url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/wifipoints`;
            break;
        case 'customer_service':
            url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/wifipoints`;
            break;
    }

    return api.get(url);
}

export function saveCompanyWifipoints(data){
    let url;
    switch(data.user_role) {
        case 'system_admin':
            url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/wifipoints`;
            break;
        case 'customer_service':
            url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/wifipoints`;
            break;
    }

    let form = new FormData();
    form.append("points", JSON.stringify(data.points));

    return api.putForm(url, form);
}

export function deleteCompanyWifiPoint (data) {
    let url;
    switch(data.user_role) {
        case 'system_admin':
            url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/wifipoints/${data.wifipoint_id}`;
            break;
        case 'customer_service':
            url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/wifipoints/${data.wifipoint_id}`;
            break;
    }

    return api.delete(url);
}
